import axios from "axios";

function them(donViHanhChinh){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dvhc/them",donViHanhChinh);
}

function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dvhc/getall");
};

function capNhat(donViHanhChinh){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dvhc/capnhat",donViHanhChinh);

};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dvhc/xoa",ids);
};

const DonViHanhChinhService={
  them,
  getAll,
  capNhat,
  xoa

};
export default DonViHanhChinhService;
